import React from 'react';
import { createFragmentContainer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Table, TableBody, TableCell, TableHead, TableSortLabel, TableRow, Paper } from '@mui/material';
import { Edit, LibraryBooks } from '@mui/icons-material';

const styleSheet = theme => ({
  paper: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflow: 'auto',
  },
  editicon: {
    width: 20,
    height: 20,
  },
});

class AccountList extends React.Component {
  goTo(url, als) {
    if (url == null)
      return;

    /*if (als != null) {
      localStorage.setItem('alsAssetBalance',     als.assetBalance);
      localStorage.setItem('alsLiabilityBalance', als.liabilityBalance);
      localStorage.setItem('alsEquityBalance',    als.equityBalance);
      localStorage.setItem('alsMaxPayoutBalance', als.maxPayoutBalance);
    }*/
    const sterm = this.props.sterm;
    if (sterm != null)
    {
        localStorage.setItem('accountsSterms', sterm);
    }
    this.props.history.push(`${url}`);
  }
    
  toggleOrder = (ob) => {
    let newDir = 0;
    if (ob === this.props.orderBy) {
      if (this.props.orderDirection === 0) {
        newDir = 1;
      }
    }

    this.setOrderBy(ob, newDir);
  } 

  setOrderBy = (ob, dir) => {
    this.props.setOrderBy(ob, dir);
  }

  render () {
    const { isAdminUser } = this.props.auth;
    const classes = this.props.classes;
    //const sterm = this.props.sterm;

    let theDir = 'asc';
    if (this.props.orderDirection === 1) {
      theDir = 'desc';
    }
    return (
      <Paper className={classes.paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Account type</TableCell>
              <TableCell>
                <TableSortLabel
                  active={this.props.orderBy === 0}
                  direction={theDir}
                  onClick={() => this.toggleOrder(0) }>
                  Account name
                </TableSortLabel>
              </TableCell>
              <TableCell>Contact email</TableCell>
                {/*
                <TableCell>Description</TableCell>
                */}
              <TableCell align="right">Status</TableCell>
              <TableCell align="right">Float Limit</TableCell>
              <TableCell align="right">Max Charge</TableCell>
              <TableCell>
                <TableSortLabel
                  active={this.props.orderBy === 1}
                  direction={theDir}
                  onClick={() => this.toggleOrder(1) }>
                  Created
                </TableSortLabel>
              </TableCell>
              <TableCell/>
              { isAdminUser() && 
              <TableCell/>
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.al.nodes.map(n => {
              let theUrl=null;
              let viewLedgerLink = "accountledgers?accountId=" + n.accountId + "&accountName=" + n.accountName;
              if (n.accountType === 1) {
                theUrl = "./vendor?accountId=" + n.accountId;
              }
              else if (n.accountType === 3) {
                theUrl = "./reseller?accountId=" + n.accountId;
              }
              else if (n.accountType === 4) {
                theUrl = "./customer?accountId=" + n.accountId;
              }
              let status = 'Unknown';
              if (n.accountStatus === 0) {
                status = 'Active';
              } else if (n.accountStatus === 1) {
                status = 'Suspended';
              } else if (n.accountStatus === 2) {
                status = 'Pending';
              } else if (n.accountStatus === 3) {
                status = 'Cancelled';
              }

              let cdate = n.created.split("T");

              let floatLimit = Number(n.floatLimit)
                               .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              if (floatLimit === '-$0.00') {
                floatLimit = '$0.00';
              }

              let maxCharge = Number(n.maxCharge)
                                  .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
              if (maxCharge === '-$0.00') {
                maxCharge = '$0.00';
              }
        
              return (
                <TableRow key={n.accountId}>
                  <TableCell>
                    { n.accountType === 0 && (<div>AppBind</div>) }
                    { n.accountType === 1 && (<div>Vendor</div>) }
                    { n.accountType === 2 && (<div>Distributor</div>) }
                    { n.accountType === 3 && (<div>Reseller</div>) }
                    { n.accountType === 4 && (<div>Customer</div>) }
                  </TableCell>
                  <TableCell>
                    {n.accountName}
                  </TableCell>
                  <TableCell>
                    {n.contactEmail}
                  </TableCell>
                  {/*
                  <TableCell>
                    {n.description}
                  </TableCell>
                  */}
                  {/* <TableCell>{als.maxPayoutBalance}</TableCell> */}
                  <TableCell align="right">{status}</TableCell>
                  <TableCell align="right">{floatLimit}</TableCell>
                  <TableCell align="right">{maxCharge}</TableCell>
                  <TableCell>
                    {cdate[0]}
                  </TableCell>
                  <TableCell>
                    <Button 
                      color="primary"
                      variant="outlined"
                      onClick={() => {this.goTo(theUrl, null);}}
                    >
                      <Edit className={classes.editicon}/>
                    </Button>
                  </TableCell>
                  { isAdminUser() && 
                  <TableCell>
                    <Button 
                      color="primary"
                      variant="outlined"
                      onClick={() => {this.goTo(viewLedgerLink);}}
                    >
                      <LibraryBooks className={classes.editicon}/>
                    </Button>
                  </TableCell>
                  }
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
    );
  }
}

AccountList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(AccountList), { al: graphql`
  fragment AccountList_al on AccountTsConnection {
    nodes {
      accountId,
      accountType,
      contactEmail,
      accountNum,
      accountName,
      description,
      accountStatus,
      floatLimit,
      maxCharge,
      created
    }
  }
`});
